import {css} from 'styled-components';
import logoSho from './icons/sho/logo-sho.svg';
import progress1 from './icons/sho/step-indicator-1.svg';
import progress2 from './icons/sho/step-indicator-2.svg';
import progress3 from './icons/sho/step-indicator-3.svg';
import progress1of2 from './icons/sho/step-indicator-1of2.svg';
import progress2of2 from './icons/sho/step-indicator-2of2.svg';
import whatsapp from './icons/sho/whatsapp.png';
import facebook from './icons/sho/facebook.svg';
import linkedin from './icons/sho/linkedin.svg';
import instagram from './icons/sho/instagram.svg';
import twitter from './icons/sho/x.svg';

const primaryColor = '#199A57';
const primary = '#f7cc26';
const hover = '#ffe255';
const errorColor = '#E8141E';

export default {
  // GlobalStyles
  bodyFontFamily: '"Maax Regular", "Arial", "sans-serif"',
  h1FontFamily: '"Maax Bold", "Arial", "sans-serif"',
  h3FontFamily: '"Maax Regular", "Arial", "sans-serif"',
  h1FontSize: '26px',
  bodyFontSize: '18px',
  // AmountButton
  amountButton: {
    color: primaryColor,
    fontFamily: '"Maax Bold", "Arial", "sans-serif"',
    fontSize: '18px',
    width: '94px',
    height: '78px',
    border: '1px solid #C4C4C4',
    borderRadius: '4px',
    backgroundColor: '#fff',
    backgroundColorActive: '#F3FAF6',
    borderHover: `1px solid ${primaryColor}`,
    boxShadowHover: `inset 0px 0px 0px 1px ${primaryColor}`
  },
  frequencyButton: {
    color: primaryColor,
    fontFamily: '"Maax Bold", "Arial", "sans-serif"',
    fontSize: '18px',
    width: '94px',
    height: '78px',
    border: '1px solid #C4C4C4',
    borderRadius: '4px',
    backgroundColor: '#fff',
    backgroundColorActive: '#F3FAF6',
    borderHover: `1px solid ${primaryColor}`,
    boxShadowHover: `inset 0px 0px 0px 1px ${primaryColor}`
  },
  buttonContainerSpaceBetween: {
    width: '94px'
  },
  frequencyButtonContainer: {
    width: '94px'
  },
  //BackButton
  backButton: {
    fontSize: '16px',
    color: '#1A1A1A'
  },
  // Box
  boxComponent: {
    borderRadius: '0'
  },
  // Button
  button: {
    fontFamily: '"Maax Bold", "Arial" ,"sans-serif"',
    fontSize: '20px',
    height: '56px',
    backgroundColor: primary,
    color: '#000',
    boxShadow: 'none',
    active: css`
      background-color: ${hover};
      border-bottom: none;
      box-shadow: none !important;
    `,
    hover: css`
      background-color: ${hover};
    `,
    focus: css`
      box-shadow: none;
    `
  },
  // Checkbox
  inputCheckbox: {
    border: '1px solid #C4C4C4'
  },
  box: {
    fontSize: '16px',
    colorHasError: errorColor,
    borderHasError: `1px solid ${errorColor}`,
    borderHover: '1px solid #818181',
    backgroundColorChecked: primaryColor,
    backgroundBorderChecked: '1px solid #199A57'
  },
  // DateInput
  dateDropdown: {
    padding: '15.6px 30px 12.4px 10px',
    border: '1px solid #c4c4c4',
    boxShadowFocus: '0 0 0 3px #c4c4c4',
    borderFocus: '1px solid transparent',
    boxShadowError: '0 0 0 1px #E8141E',
    boxShadowValid: '0 0 0 1px #199A57'
  },
  // DisplayIban
  iban: {
    fontFamily: '"Maax Bold", "Arial", "sans-serif"',
    color: '#fff'
  },
  // Dropdown
  dropdown: {
    height: '46px',
    borderRadius: '4px',
    backgroundColor: '#fff',
    fontSize: '18px',
    paddingLeft: '13px',
    border: '1px solid #c4c4c4',
    borderFocus: '1px solid transparent',
    boxShadowFocus: '0 0 0 2px #818181'
  },
  // ErrorMessage
  error: {
    backgroundColor: '#f3f3f3',
    color: '#e8141e',
    height: '49px'
  },
  // Iban
  ibanContainer: {
    display: 'inline-block'
  },
  // Input
  inputComponent: {
    fontSize: '18px',
    border: '1px solid #c4c4c4',
    borderFocus: '1px solid #818181',
    boxShadowFocus: 'none',
    colorPlaceholder: '#c4c4c4',
    borderValid: '1px solid #199a57',
    boxShadowValid: 'none',
    backgroundColorValid: '#F3FAF6',
    borderError: '1px solid #E8141E',
    boxShadowError: 'none',
    colorError: '#E8141E',
    backgroundColorError: '#FFE5E6'
  },
  // TextArea
  textAreaComponent: {
    fontSize: '18px',
    border: '1px solid #c4c4c4',
    borderFocus: '1px solid #818181',
    boxShadowFocus: 'none',
    colorPlaceholder: '#c4c4c4',
    borderValid: '1px solid #199a57',
    boxShadowValid: 'none',
    backgroundColorValid: '#F3FAF6',
    borderError: '1px solid #E8141E',
    boxShadowError: 'none',
    colorError: '#E8141E',
    backgroundColorError: '#FFE5E6'
  },
  // Label
  optionalLabel: {
    color: '#818181'
  },
  label: {
    fontSize: '16px',
    color: '#000',
    colorError: '#E8141E'
  },
  logo: {
    width: '128px',
    height: '102px',
    backgroundImage: logoSho,
    widthMobile: '73px',
    heightMobile: '58px',
    margin: '0',
    marginMobile: '0'
  },
  // PaymentButton
  paymentButton: {
    color: primaryColor,
    fontFamily: '"Maax Regular", "Arial", "sans-serif"',
    fontSize: '14px',
    width: '94px',
    height: '78px',
    lineHeight: '78px',
    border: '1px solid #C4C4C4',
    borderRadius: '4px',
    backgroundColor: '#fff',
    backgroundColorActive: '#F3FAF6',
    borderHover: `1px solid ${primaryColor}`,
    boxShadowHover: `inset 0px 0px 0px 1px ${primaryColor}`
  },
  // RadioButton
  inputRadioButton: {
    backgroundColor: '#fff',
    border: '1px solid #c4c4c4',
    backgroundColorActive: '#199a57',
    borderActive: '1px solid #199a57'
  },
  // ProgressBar
  progressBar: {
    step1: css`
      width: 70px;
      background: url(${progress1}) no-repeat 0;
    `,
    step2: css`
      width: 70px;
      background: url(${progress2}) no-repeat 0;
    `,
    step3: css`
      width: 70px;
      background: url(${progress3}) no-repeat 0;
    `,
    step1of2: css`
      width: 40px;
      background: url(${progress1of2}) no-repeat 0;
    `,
    step2of2: css`
      width: 40px;
      background: url(${progress2of2}) no-repeat 0;
    `
  },
  radio: {
    borderHover: '1px solid #818181',
    colorHasError: '#e8141e',
    borderHasError: '1px solid #e8141e'
  },
  // TeaserHeader
  teaser: {
    display: 'inline',
    fontFamily: '"Maax Bold", "Arial", "sans-serif"',
    fontWeight: 'normal',
    fontSize: '41px',
    lineHeight: '51px',
    fontSizeTablet: '54px',
    lineHeightTablet: '65px',
    fontSizeWide: '54px',
    lineHeightWide: '65px',
    subtitleFontFamily: '"Maax Bold", "Arial", "sans-serif"',
    subtitleFontSize: '19px',
    subtitleLineHeight: '29px',
    subtitleFontSizeWide: '20px',
    subtitleLineHeightWide: '30px',
    subtitleFontSizeTablet: '20px',
    subtitleLineHeightTablet: '30px',
    backgroundColor: 'rgba(26,26,26,0.85)',
    backgroundColorSubtitle: 'rgba(26,26,26,0.85)',
    color: '#fff',
    colorSubtitle: '#fff',
    padding: '5px 17px',
    paddingTop: '10px',
    // paddingTopSubtitle: '5px',
    topLeftTextAlignment: 'left',
    topRightTextAlignment: 'right',
    bottomLeftTextAlignment: 'left',
    bottomRightTextAlignment: 'right'
  },
  teaserContainer: {
    margin: '0'
  },
  // Title
  title: {
    color: '#fff',
    fontFamily: '"Maax Bold", "Arial", "sans-serif"',
    fontSize: '26px',
    height: '65px',
    fontWeight: 'normal',
    borderRadius: '0',
    backgroundColor: '#000',
    multiLine: true
  },
  // Validation
  validation: {
    color: '#e8141e',
    fontSize: '16px'
  },
  // OptIn
  optInButton: {
    fontFamily: 'Maax Bold',
    fontSize: '20px',
    backgroundColor: '#000',
    color: primary,
    boxShadow: 'none',
    active: css`
      background-color: #000;
      border-bottom: none;
      box-shadow: none !important;
    `,
    hover: css`
      background-color: #000;
    `,
    focus: css`
      box-shadow: none;
    `
  },
  // SocialShareButton
  socialShareButton: {
    backgroundSize: '50px',
    color: '#000',
    whatsapp: css`background-image: url(${whatsapp})`,
    facebook: css`background-image: url(${facebook})`,
    twitter: css`background-image: url(${twitter})`,
    linkedin: css`background-image: url(${linkedin})`,
    instagram: css`background-image: url(${instagram})`
  }
};


